import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';

export const AfibShopifyMap =
  process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
    ? {
      [ShopifyStore.IN]: {
        Year1: {
          variantId: '',
          alternateVariantId: '',
          price: 4999,
        },
        Year2: {
          variantId: '',
          alternateVariantId: '',
          price: 6599,
          save: 34,
        },
      },
      [ShopifyStore.AE]: {
        Year1: {
          variantId: 'gid://shopify/ProductVariant/63058479120755',
          alternateVariantId: 'gid://shopify/ProductVariant/63058479120755',
          price: 199.99,
        },
        Year2: {
          variantId: 'gid://shopify/ProductVariant/63058612519283',
          alternateVariantId: 'gid://shopify/ProductVariant/63058612519283',
          price: 259.99,
          save: 35,
        },
      },
      [ShopifyStore.EU]: {
        Year1: {
          variantId: 'gid://shopify/ProductVariant/55121006821750',
          alternateVariantId: 'gid://shopify/ProductVariant/55121006821750',
          price: 49,
        },
        Year2: {
          variantId: 'gid://shopify/ProductVariant/55176328020342',
          alternateVariantId: 'gid://shopify/ProductVariant/55176328020342',
          price: 79,
          save: 19,
        },
      },
      [ShopifyStore.GB]: {
        Year1: {
          variantId: 'gid://shopify/ProductVariant/55121006821750',
          alternateVariantId: 'gid://shopify/ProductVariant/55121006821750',
          price: 49,
        },
        Year2: {
          variantId: 'gid://shopify/ProductVariant/55176328020342',
          alternateVariantId: 'gid://shopify/ProductVariant/55176328020342',
          price: 79,
          save: 19,
        },
      },
      [ShopifyStore.ROW]: {
        Year1: {
          variantId: 'gid://shopify/ProductVariant/42449043030076',
          alternateVariantId: 'gid://shopify/ProductVariant/42449043030076',
          price: 48,
        },
        Year2: {
          variantId: 'gid://shopify/ProductVariant/42493701718076',
          alternateVariantId: 'gid://shopify/ProductVariant/42493701718076',
          price: 78,
          save: 19,
        },
      },
      // No AFib product exists on the US/CA backend (stelcore-x-ultrahuman);
      // the old IDs did not resolve. Fill real IDs to enable.
      [ShopifyStore.US]: {
        Year1: {
          variantId: '',
          alternateVariantId: '',
          price: 48,
        },
        Year2: {
          variantId: '',
          alternateVariantId: '',
          price: 78,
          save: 19,
        },
      },
      [ShopifyStore.AU]: {
        Year1: {
          variantId: 'gid://shopify/ProductVariant/55121006821750',
          alternateVariantId: 'gid://shopify/ProductVariant/55121006821750',
          price: 79,
        },
        Year2: {
          variantId: 'gid://shopify/ProductVariant/55176328020342',
          alternateVariantId: 'gid://shopify/ProductVariant/55176328020342',
          price: 156,
          save: 1,
        },
      },
      [ShopifyStore.CA]: {
        Year1: {
          variantId: '',
          alternateVariantId: '',
          price: 69,
        },
        Year2: {
          variantId: '',
          alternateVariantId: '',
          price: 78,
          save: 43,
        },
      },
      [ShopifyStore.SA]: {
        Year1: {
          variantId: 'gid://shopify/ProductVariant/55121006821750',
          alternateVariantId: 'gid://shopify/ProductVariant/55121006821750',
          price: 251,
        },
        Year2: {
          variantId: 'gid://shopify/ProductVariant/55176328020342',
          alternateVariantId: 'gid://shopify/ProductVariant/55176328020342',
          price: 399,
          save: 21,
        },
      },
      [ShopifyStore.MX]: {
        Year1: {
          variantId: 'gid://shopify/ProductVariant/55121006821750',
          alternateVariantId: 'gid://shopify/ProductVariant/55121006821750',
          price: 48,
        },
        Year2: {
          variantId: 'gid://shopify/ProductVariant/55176328020342',
          alternateVariantId: 'gid://shopify/ProductVariant/55176328020342',
          price: 78,
          save: 19,
        },
      },
      [ShopifyStore.ZA]: {
        Year1: {
          variantId: 'gid://shopify/ProductVariant/55121006821750',
          alternateVariantId: 'gid://shopify/ProductVariant/55121006821750',
          price: 48,
        },
        Year2: {
          variantId: 'gid://shopify/ProductVariant/55176328020342',
          alternateVariantId: 'gid://shopify/ProductVariant/55176328020342',
          price: 78,
          save: 19,
        },
      },
      [ShopifyStore.JP]: {
        Year1: {
          variantId: 'gid://shopify/ProductVariant/55121006821750',
          alternateVariantId: 'gid://shopify/ProductVariant/55121006821750',
          price: 8800,
        },
        Year2: {
          variantId: 'gid://shopify/ProductVariant/55176328020342',
          alternateVariantId: 'gid://shopify/ProductVariant/55176328020342',
          price: 13800,
          save: 22,
        },
      },
    }
    : {
      [ShopifyStore.ZA]: {
        Year1: {
          variantId: 'gid://shopify/ProductVariant/55121006821750',
          alternateVariantId: 'gid://shopify/ProductVariant/55121006821750',
          price: 48,
        },
        Year2: {
          variantId: 'gid://shopify/ProductVariant/55176328020342',
          alternateVariantId: 'gid://shopify/ProductVariant/55176328020342',
          price: 78,
          save: 19,
        },
      },
      [ShopifyStore.IN]: {
        Year1: {
          variantId: '',
          alternateVariantId: '',
          price: 4999,
        },
        Year2: {
          variantId: '',
          alternateVariantId: '',
          price: 6599,
          save: 34,
        },
      },
      [ShopifyStore.AE]: {
        Year1: {
          variantId: 'gid://shopify/ProductVariant/63058479120755',
          alternateVariantId: 'gid://shopify/ProductVariant/63058479120755',
          price: 199.99,
        },
        Year2: {
          variantId: 'gid://shopify/ProductVariant/63058612519283',
          alternateVariantId: 'gid://shopify/ProductVariant/63058612519283',
          price: 259.99,
          save: 35,
        },
      },
      [ShopifyStore.EU]: {
        Year1: {
          variantId: 'gid://shopify/ProductVariant/55121006821750',
          alternateVariantId: 'gid://shopify/ProductVariant/55121006821750',
          price: 49,
        },
        Year2: {
          variantId: 'gid://shopify/ProductVariant/55176328020342',
          alternateVariantId: 'gid://shopify/ProductVariant/55176328020342',
          price: 79,
          save: 19,
        },
      },
      [ShopifyStore.GB]: {
        Year1: {
          variantId: 'gid://shopify/ProductVariant/55121006821750',
          alternateVariantId: 'gid://shopify/ProductVariant/55121006821750',
          price: 49,
        },
        Year2: {
          variantId: 'gid://shopify/ProductVariant/55176328020342',
          alternateVariantId: 'gid://shopify/ProductVariant/55176328020342',
          price: 79,
          save: 19,
        },
      },
      [ShopifyStore.ROW]: {
        Year1: {
          variantId: 'gid://shopify/ProductVariant/42449043030076',
          alternateVariantId: 'gid://shopify/ProductVariant/42449043030076',
          price: 48,
        },
        Year2: {
          variantId: 'gid://shopify/ProductVariant/42493701718076',
          alternateVariantId: 'gid://shopify/ProductVariant/42493701718076',
          price: 78,
          save: 19,
        },
      },
      [ShopifyStore.US]: {
        Year1: {
          variantId: '',
          alternateVariantId: '',
          price: 48,
        },
        Year2: {
          variantId: '',
          alternateVariantId: '',
          price: 78,
          save: 19,
        },
      },
      [ShopifyStore.AU]: {
        Year1: {
          variantId: 'gid://shopify/ProductVariant/55121006821750',
          alternateVariantId: 'gid://shopify/ProductVariant/55121006821750',
          price: 79,
        },
        Year2: {
          variantId: 'gid://shopify/ProductVariant/55176328020342',
          alternateVariantId: 'gid://shopify/ProductVariant/55176328020342',
          price: 156,
          save: 1,
        },
      },
      [ShopifyStore.CA]: {
        Year1: {
          variantId: '',
          alternateVariantId: '',
          price: 69,
        },
        Year2: {
          variantId: '',
          alternateVariantId: '',
          price: 78,
          save: 43,
        },
      },
      [ShopifyStore.SA]: {
        Year1: {
          variantId: 'gid://shopify/ProductVariant/41515247075424',
          alternateVariantId: 'gid://shopify/ProductVariant/41515247075424',
          price: 251,
        },
        Year2: {
          variantId: 'gid://shopify/ProductVariant/41559574216800',
          alternateVariantId: 'gid://shopify/ProductVariant/41559574216800',
          price: 399,
          save: 21,
        },
      },
      [ShopifyStore.MX]: {
        Year1: {
          variantId: 'gid://shopify/ProductVariant/41515247075424',
          alternateVariantId: 'gid://shopify/ProductVariant/41515247075424',
          price: 48,
        },
        Year2: {
          variantId: 'gid://shopify/ProductVariant/41559574216800',
          alternateVariantId: 'gid://shopify/ProductVariant/41559574216800',
          price: 78,
          save: 19,
        },
      },
      [ShopifyStore.JP]: {
        Year1: {
          variantId: 'gid://shopify/ProductVariant/55121006821750',
          alternateVariantId: 'gid://shopify/ProductVariant/55121006821750',
          price: 8800,
        },
        Year2: {
          variantId: 'gid://shopify/ProductVariant/55176328020342',
          alternateVariantId: 'gid://shopify/ProductVariant/55176328020342',
          price: 13800,
          save: 22,
        },
      },
    };


export const hasAfibVariants = (store: ShopifyStore): boolean =>
  !!(
    AfibShopifyMap[store]?.Year1?.variantId &&
    AfibShopifyMap[store]?.Year2?.variantId
  );
